import React from "react";
import { 
    TextField, 
    Input, 
    Select, 
    type,
    FormControl, 
    InputLabel, 
    FormControlLabel, 
    Checkbox,
    MenuItem, 
    FormHelperText,
    Grid,
    Box} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";  
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs"; 


const PersonalInfoStep = ({formData, errors, onChange})=>{
    
    return(
        <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={3} className="mt-10">
                <Grid item xs ={12}>
                <TextField 
                fullWidth
                label="Full name"
                value={formData.fullname}
                onChange={(e)=> onChange('fullname', e.target.value)}
                error={!!errors.fullname}
                helperText={errors.fullname}
                />
               
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                    fullWidth
                    label ="Email"
                    value={formData.email}
                    type="email"
                    onChange={(e)=> onChange('email', e.target.value)}
                    error={!! errors.email}
                    helperText={errors.email}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                    fullWidth
                    label ="Mobile"
                    value={formData.mobile}
                    type="number"
                    onChange={(e)=> onChange('mobile', e.target.value)}
                    error={!! errors.mobile}
                    helperText={errors.mobile}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DatePicker
                    label="Date of birth"
                    value={formData.dob ? dayjs(formData.dob) : null}
                    onChange={(date)=> onChange('dob', date?.format("YYYY/MM/DD"))}
                   
                    slotProps={{
                        textField:{
                           fullWidth:true,
                            error:!!errors.dob,
                            helperText : errors.dob
                        }
                    }}
                    >

                    </DatePicker>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth error={!!errors.gender}>
                    {/* <label>Gender</label> */}
                    <Select 
                    value={formData.gender}
                    // label="Gender"
                    onChange={(e)=> onChange("gender", e.target.value)}
                    displayEmpty     
                    // helperText={errors.gender}              
                    >
                    <MenuItem value="">Select Relationship</MenuItem>
                        <MenuItem value="Son">Son</MenuItem>
              <MenuItem value="Daughter">Daughter</MenuItem>
                    </Select>
                     {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                    <div className="input_field checkbox_option clearfix">
                <input type="checkbox" name="tmc" className="termcondition "checked={formData.tmc}
                onChange={(e) => onChange('tmc', e.target.checked)}/>
                <label>I agree with terms and conditions</label>
              </div>
              {errors.tmc && <div className="error-text">{errors.tmc}</div>}
              </Box>
                </Grid>
                
            </Grid>
            
        </LocalizationProvider>
        </>
    )
}
export {PersonalInfoStep}